"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExpressView_1 = require("./ExpressView");
exports.default = ExpressView_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/ExpressView/index.js
// module id = 794
// module chunks = 8